export default {

  init() {

    this.initLoopingVideo();

    $( document ).on( 'click', '.js-video-play-inline', this.playInlineVideo );
    $( document ).on( 'click', '.js-video-play-modal', this.playModalVideo );
    $( document ).on( 'click', '.js-video-close-modal', this.closeModalVideo );

  },

  initLoopingVideo() {

    if ( document.querySelector( '.js-looping-video' ) == null ) {
      return;
    }

    const videos = document.querySelectorAll( '.js-looping-video' );

    for (var i = 0; i < videos.length; i++) {
      const video = videos[i];

      const mp4 = video.dataset.video_mp4;
      const ogv = video.dataset.video_ogv;
      const webm = video.dataset.video_webm;

      const videoAttrs = 'autoloop loop autobuffer playsinline muted';
      const flashvars = 'repeat=always';

      const videoHTML = "<video class=\"video\" width=\"1920\" height=\"1440\" autobuffer preload=\"auto\"" + videoAttrs + "> \t\t\t\t\t\t\t<source type=\"video/webm\" src=\"" + webm + "\"> \t\t\t\t\t\t\t<source type=\"video/mp4\" src=\"" + mp4 + "\"> \t\t\t\t\t\t\t<source type=\"video/ogg\" src=\"" + ogv + "\"> \t\t\t\t\t\t\t<object class=\"video\" type=\"application/x-shockwave-flash\" data=\"//player.longtailvideo.com/player.swf\" width=\"960\" height=\"720\"> \t\t\t\t\t\t\t\t<param name=\"movie\" value=\"//player.longtailvideo.com/player.swf\" /> \t\t\t\t\t\t\t\t<param name=\"allowFullScreen\" value=\"false\" /> \t\t\t\t\t\t\t\t<param name=\"wmode\" value=\"transparent\" /> \t\t\t\t\t\t\t\t<param name=\"flashVars\" value=\"" + flashvars + "controlbar=none&amp;file=" + encodeURIComponent(mp4) + "\" /> \t\t\t\t\t\t\t</object> \t\t\t\t\t\t</video>"

      video.innerHTML = videoHTML;
      const vidEl = video.querySelector( '.video' );

      const videoLoadedCallback = () => {

        vidEl.play();

        $( video ).fadeIn();

      }

      if ( vidEl.readyState == 4 ) {
        videoLoadedCallback()
      } else {
        $( video ).find( ".video" ).on( "canplay", videoLoadedCallback );
      }

    }

  },

  playInlineVideo( event ) {

    const videoContainer = event.currentTarget.parentElement.querySelector( '.js-video-container' );
    const videoUrl = event.currentTarget.dataset.video_url;
    var videoHtml = '';

    if ( videoUrl.indexOf( 'youtube' ) > 0 ) {

      const params = videoUrl.split( '?' );
      const videoID = params[1].split( '=' )[1];

      videoHtml = '<iframe src="https://www.youtube.com/embed/' + videoID + '?modestbranding=1&autohide=1&rel=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

    } else if ( videoUrl.indexOf( 'vimeo' ) > 0 ) {

      const params = videoUrl.split( '/' );
      const videoID = params[params.length - 1];

      videoHtml = '<iframe src="https://player.vimeo.com/video/' + videoID + '?autoplay=1&loop=1&autopause=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
    }

    videoContainer.innerHTML = videoHtml;
    $( videoContainer ).delay( 1300 ).fadeIn();

  },

  playModalVideo( event ) {

    const videoContainerID = event.currentTarget.dataset.modal;
    const videoContainer = document.querySelector( '[data-modal_el="' + videoContainerID + '"]' );
    const videoUrl = event.currentTarget.dataset.video_url;
    var videoHtml = '';

    if ( videoUrl.indexOf( 'youtube' ) > 0 ) {

      const params = videoUrl.split( '?' );
      const videoID = params[1].split( '=' )[1];

      videoHtml = '<iframe src="https://www.youtube.com/embed/' + videoID + '?modestbranding=1&autohide=1&rel=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

    } else if ( videoUrl.indexOf( 'vimeo' ) > 0 ) {

      const params = videoUrl.split( '/' );
      const videoID = params[params.length - 1];

      videoHtml = '<iframe src="https://player.vimeo.com/video/' + videoID + '?autoplay=1&loop=1&autopause=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
    }

    videoContainer.querySelector( '.js-video-container' ).innerHTML = videoHtml;
    $( videoContainer ).delay( 1300 ).fadeIn( () => {
      $( 'body' ).addClass( 'modal-open' );
    });

  },

  closeModalVideo( event ) {

    const $el = $( event.currentTarget );

    $el.parents( '.js-video-overlay' ).fadeOut( () => {
      $( 'body' ).removeClass( 'is-video-overlay-open scroll-mask' );
      $el.siblings( '.js-video-container' ).find( 'iframe' ).remove();
    });

  },
}



// WEBPACK FOOTER //
// ./scripts/modules/video.js